/**
 * Where a column's content sits.
 *
 * Alignment is an explicit setting rather than something inferred from the
 * kind of data: a column that quietly right-aligns itself while its neighbours
 * do not is the sort of inconsistency nobody can explain from the config.
 */
export type ColumnAlign = 'left' | 'right' | 'center';

export const DEFAULT_COLUMN_ALIGN: ColumnAlign = 'left';

/**
 * Resolve one column's alignment: its own setting, else the explorer-wide
 * default, else left. Lives in core so both renderers resolve it identically.
 */
export function resolveColumnAlign(
  columnAlign: ColumnAlign | undefined,
  explorerDefault: ColumnAlign | undefined,
): ColumnAlign {
  return columnAlign ?? explorerDefault ?? DEFAULT_COLUMN_ALIGN;
}

/** The class a renderer puts on the cell and its header. */
export function alignClass(align: ColumnAlign): string {
  return `de-cell--align-${align}`;
}
